import { useNavigate } from "react-router-dom";
import { CalendarCheck, Phone, MessageCircle } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function MobileBookBar() {
  const { t, settings } = useApp();
  const nav = useNavigate();
  const phone = settings?.contact?.phone;
  const wa = settings?.contact?.whatsapp;
  return (
    <div
      className="sm:hidden fixed bottom-0 inset-x-0 z-40 cb-glass border-t border-border px-3 pt-2.5 flex items-center gap-2"
      style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
      data-testid="mobile-book-bar"
    >
      <button
        onClick={() => nav("/book")}
        data-testid="mobile-book-bar-book-btn"
        className="flex-1 h-12 rounded-full cb-gradient text-primary-foreground font-bold text-base flex items-center justify-center gap-2 shadow-md active:scale-[0.98] transition-transform"
      >
        <CalendarCheck className="h-5 w-5" /> {t.nav.book}
      </button>
      {wa && (
        <a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="mobile-book-bar-whatsapp"
          className="grid place-items-center h-12 w-12 rounded-full bg-[#25D366] text-white shadow-md">
          <MessageCircle className="h-6 w-6" />
        </a>
      )}
      {phone && (
        <a href={`tel:${phone}`} aria-label="Call" data-testid="mobile-book-bar-call"
          className="grid place-items-center h-12 w-12 rounded-full bg-secondary text-secondary-foreground shadow-md">
          <Phone className="h-5 w-5" />
        </a>
      )}
    </div>
  );
}
